import type { i18n as I18nInstance } from 'i18next';

export type AppLanguage = 'es' | 'en';

/**
 * Idioma efectivo de la app: nunca `undefined`, nunca un tag regional.
 *
 * Es el único punto autorizado para leer el idioma de i18next (ver capability
 * `webapp-default-language`). `i18n.language` conserva variantes regionales
 * (`'es-ES'`) y `i18n.resolvedLanguage` es opcional en los tipos de i18next.
 */
export const appLanguage = (i18n: Pick<I18nInstance, 'resolvedLanguage'>): AppLanguage =>
  i18n.resolvedLanguage === 'es' ? 'es' : 'en';
